export const DASHBOARD_STATE_STORAGE_KEY = "manageDashboardState";
export const DEFAULT_DASHBOARD_RETURN_STATE_TTL_HOURS = 6;

const VALID_DASHBOARD_VIEWS = ["month", "week", "day"];

export function getDashboardStateTtlMs(ttlHours = DEFAULT_DASHBOARD_RETURN_STATE_TTL_HOURS) {
  const parsedTtl = Number(ttlHours);
  const safeTtlHours = Number.isInteger(parsedTtl) && parsedTtl > 0
    ? parsedTtl
    : DEFAULT_DASHBOARD_RETURN_STATE_TTL_HOURS;

  return safeTtlHours * 60 * 60 * 1000;
}

export function readDashboardState(ttlHours = DEFAULT_DASHBOARD_RETURN_STATE_TTL_HOURS, now = Date.now()) {
  if (typeof localStorage === "undefined") return null;

  try {
    const rawState = localStorage.getItem(DASHBOARD_STATE_STORAGE_KEY);
    if (!rawState) return null;

    const state = JSON.parse(rawState);
    const savedAt = Number(state.savedAt);
    const date = new Date(state.date);

    if (!savedAt || now - savedAt > getDashboardStateTtlMs(ttlHours)) return null;
    if (Number.isNaN(date.getTime())) return null;

    return {
      teacherId: state.teacherId,
      view: VALID_DASHBOARD_VIEWS.includes(state.view) ? state.view : undefined,
      date,
    };
  } catch (error) {
    return null;
  }
}

export function writeDashboardState({
  teacherId,
  view,
  date,
}, now = Date.now()) {
  if (typeof localStorage === "undefined" || !teacherId || !date) return;

  localStorage.setItem(DASHBOARD_STATE_STORAGE_KEY, JSON.stringify({
    teacherId,
    view,
    date: date.toISOString(),
    savedAt: now,
  }));
}
